import React, { useCallback, useState } from "react";

import { LinkCustom } from "../../../../components/navigation/LinkCustom/LinkCustom";
import getIframeHeight from "../../utils/getIframeHeight";

import IFrame from "./IFrame";
import useIframeCommand from "./hooks/useIframeCommand";
import useCurrentIframe from "./hooks/useCurrentIframe";
import IframeMenu from "./IframeMenu";

import styles from "./styles.module.scss";

const IFrameCommand = React.memo(({
    data,
    onElementClick,
    menuProps,
    onSetIframe,
    onSetIframeWrapper
}) => {
    const { html, url, http_response_code } = data;
    const [ wrapperHeight, setWrapperHeight ] = useState(0);
    const { iframeRef, iframeWrapperRef } = useCurrentIframe(onSetIframe, onSetIframeWrapper);

    const handleElementClick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if(typeof onElementClick === "function") {
            onElementClick(event);
        }
    };

    useIframeCommand({
        iframeRef,
        html,
        onClickIframe: handleElementClick
    });

    const handleResize = useCallback(
        () => {
            const contentHeight = getIframeHeight(iframeRef);

            if (contentHeight !== wrapperHeight) {
                setWrapperHeight(contentHeight);
            }
        },
        [ wrapperHeight, iframeRef ]
    );

    const onLoad = useCallback(
        () => {
            iframeRef.current.contentWindow.addEventListener("resize", handleResize);

            const contentHeight = getIframeHeight(iframeRef);

            if(contentHeight) {
                setWrapperHeight(contentHeight);
            }
        },
        [ handleResize, iframeRef ]
    );

    const iframeWrapperStyles = wrapperHeight ? { height: wrapperHeight } : {};

    return (
        <div className={styles.iFrameCommand}>
            <div className={styles.iFrameCommandTitle}>
                <div>
                    Http response code: <b>{http_response_code}</b>
                </div>

                <LinkCustom
                    className={styles.url}
                    href={url}
                    target={"_blank"}
                >
                    {url}
                </LinkCustom>
            </div>

            <div
                ref={iframeWrapperRef}
                className={styles.frameCommand}
            >
                <div
                    className={styles.iframeWrapper}
                    style={iframeWrapperStyles}
                >
                    <IFrame
                        iframeRef={iframeRef}
                        onLoad={onLoad}
                    />

                    {
                        menuProps && (
                            <IframeMenu {...menuProps}/>
                        )
                    }
                </div>
            </div>
        </div>
    );
});

export default IFrameCommand;
